'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hashObj = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

exports.sortedPairs = sortedPairs;
exports.hashString = hashString;

var _lodash = require('lodash');

function sortedPairs(obj) {
  return (0, _lodash.sortBy)((0, _lodash.toPairs)(obj), function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        k = _ref2[0];

    return k;
  });
}

function hashString(str) {
  // adapted from https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
  var hash = 0;

  if (str.length === 0) {
    return hash;
  }

  for (var i = 0; i < str.length; i++) {
    var chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }

  return hash;
}

var hashObj = exports.hashObj = (0, _lodash.memoize)(function (obj) {
  var flattened = (0, _lodash.mapValues)(obj, function (v) {
    return (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' ? sortedPairs(obj) : v;
  });
  var sorted = sortedPairs(flattened);
  var json = JSON.stringify(sorted);
  return hashString(json);
});